import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import AutoSuggestField from "@FormElements/AutoSuggestField";
import FormContext from "formContext";

function SpecialismAutoSuggestField({intl, settings, ...rest}) {
  const {additionalData, currentStep, setFormData, formData, setErrors} = useContext(FormContext);

  const specialismsList = additionalData.specialisms && additionalData.specialisms.Specialisms;
  let specialismOptions = [];
  let specialismFiltered = [];
  if (specialismsList) {
    specialismOptions = Object.keys(specialismsList).map(function(key) {
      const object = specialismsList[key];
      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        const match = object.Name.toLowerCase().indexOf(formValue.toLowerCase()) !== -1;

        if (match) {
          specialismFiltered.push(specialismsList[key].Name);
        }
      }
      return specialismsList[key];
    })
  }


  settings.options = specialismFiltered;

  rest.onChange = e => {
    const {value} = e.target;
    setErrors();
    const match = specialismOptions.find(el => el.Name === value);
    if (match) {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
        }
        prev[currentStep][settings.name] = match.Name;
        prev[currentStep]['job_title'] = '';
        return {
          ...prev
        }
      });
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep]['job_title'] = '';
        return {
          ...prev
        }
      });
    }
  };

  return (
    <AutoSuggestField
      settings={settings}
      {...rest}
    />
  );
}

export default injectIntl(SpecialismAutoSuggestField);
